import { Component, OnInit } from "@angular/core";
import { DefinitionModelService } from "../../models/definition-model.service";
import { ScreenControllerService } from "../../controls/screen-controller.service";
import { DescriptorModelService } from "../../models/descriptor-model.service";
import { ApplicationModel } from "../../models/application.model";

@Component({
	selector: "app-glossary",
	templateUrl: "./glossary.component.html",
	styleUrls: ["./glossary.component.css"],
})
export class GlossaryComponent implements OnInit {
	public docOpen: boolean;
	public srcString: string;
	constructor(
		private definitionModel: DefinitionModelService,
		private screenController: ScreenControllerService,
		public descriptorService: DescriptorModelService
	) {}

	ngOnInit() {
		/*console.log(this.definitionModel.txtFields);
    console.log('=====================================')
    console.log(this.definitionModel.defaultsVal)*/
	}
	public get screenControllerVal(): ScreenControllerService {
		return this.screenController;
	}
	public get continue_label(): string {
		return this.descriptorService.getDescriptorTextById("continue_str");
	}
	public get textDirection() {
		return ApplicationModel.instance.flowDirection;
	}
}
